import axios from "axios";
import { base_url } from "../config";

const accessToken = localStorage.getItem("@user");

export const sendNotification = async () => {
  try {
    const response = await axios.post(`${base_url}/users/notification?access_token=${accessToken}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error.response ? error.response.data : error.message;
  }
};
